import React from 'react';

import {Link} from 'react-router-dom';

import {NavLink} from '@mantine/core';

import {Breadcrumbs} from 'pac-ux-components';

import TermsOfUseDocument from '../components/TermsOfUseDocument';

import {IndexPageLayout} from 'pac-platform-ui-components';
import {I18n} from '@aws-amplify/core';

export const ViewTermsOfUsePage = () => {
    return (
        <IndexPageLayout title={I18n.get('User Agreements')}>
            <Breadcrumbs>
                <NavLink
                    component={Link}
                    to="/user-agreements/list"
                    underline="hover"
                    label="User Agreements"
                />

                {I18n.get('Terms Of Use')}
            </Breadcrumbs>

            <TermsOfUseDocument />
        </IndexPageLayout>
    );
};
